// Mirror of backend TEMPLATES catalog (used for fallback when offline)
export const TEMPLATE_DEFAULTS = {
  royal_indian: { font_h: "font-playfair", font_b: "font-sans-disp" },
  floral_elegance: { font_h: "font-serif-display", font_b: "font-lato" },
  minimalist_modern: { font_h: "font-mono-disp", font_b: "font-sans-disp" },
  traditional_mandala: { font_h: "font-playfair", font_b: "font-sans-disp" },
  beach_wedding: { font_h: "font-sans-disp", font_b: "font-manrope" },
  luxury_gold_black: { font_h: "font-serif-display", font_b: "font-sans-disp" },
  boho_chic: { font_h: "font-sans-disp", font_b: "font-manrope" },
  vintage_romantic: { font_h: "font-bodoni", font_b: "font-lato" },
};

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}
